<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <div class="single_image_input_wrapper">
      <span class="input_placeholder" v-if="placeholder">
        {{ placeholder }}
        <span class="text-danger" v-if="required"> * </span>
      </span>

      <div class="wrapper relative">
        <!-- Remove Button -->
        <button
          v-if="image.file || preSelectedImage"
          type="button"
          class="remove-btn"
          @click="removeImage"
        >
          ✕
        </button>

        <label :for="identifier"></label>

        <img
          v-if="image.type == 'image_file'"
          :class="
            preSelectedImage || image.file
              ? 'image_uploaded'
              : 'image_placeholder'
          "
          :src="preSelectedImage ? preSelectedImage : image.path"
          alt="Image To Upload"
          width="100"
          height="100"
        />

        <video
          v-if="image.type == 'video_file'"
          autoplay
          controls
          loop
          muted
          class="w-100 h-100"
          ref="videoPreview"
        >
          <source :src="image.path" type="video/mp4" />
        </video>

        <input
          type="file"
          :accept="inputAccept"
          class="form-control"
          :id="identifier"
          @change="selectImageToUpload"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import predictFileType from "@/utils/predictFileType.js";

export default {
  name: "BaseImageUploadInput",

  emits: ["selectImage", "onFileRemove"],

  props: {
    col: String,
    identifier: { required: true, type: String },
    preSelectedImage: String,
    placeholder: String,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    acceptVideo: { type: Boolean, default: false },
  },

  data() {
    return {
      image: {
        path: require("@/assets/media/images/upload_image.svg"),
        file: null,
        type: "image_file",
      },
      inputAccept: "image/png, image/jpg, image/jpeg, image/jfif ,video/*",
    };
  },

  methods: {
    selectImageToUpload(e) {
      const selectedFile = e.target.files[0];
      const fileType = predictFileType(selectedFile.name);

      if (fileType !== "image_file" && !this.acceptVideo) {
        this.$message.error(this.$t("VALIDATION.selectedFileMustBeImage"));
        return;
      } else if (
        fileType !== "video_file" &&
        fileType !== "image_file" &&
        this.acceptVideo
      ) {
        this.$message.error(
          this.$t("VALIDATION.selectedFileMustBeImageOrVideo")
        );
        return;
      }

      this.image.path = URL.createObjectURL(selectedFile);
      this.image.file = selectedFile;
      this.image.type = fileType == "image_file" ? "image_file" : "video_file";
      this.$emit("selectImage", {
        identifier: this.identifier,
        ...this.image,
      });

      if (this.image.type == "video_file") {
        this.$refs.videoPreview.load();
      }
    },

    removeImage() {
      // Check if parent component has onFileRemove handler
      if (this.$attrs.onFileRemove || this.$listeners?.onFileRemove) {
        // Emit the remove event for parent to handle
        this.$emit("onFileRemove");
      } else {
        // No handler, just reset locally
        this.image = {
          path: require("@/assets/media/images/upload_image.svg"),
          file: null,
          type: "image_file",
        };

        this.$emit("selectImage", {
          identifier: this.identifier,
          file: null,
          path: null,
          type: "image_file",
        });
      }
    },
  },

  created() {
    if (this.preSelectedImage) {
      if (
        this.preSelectedImage.endsWith("png") ||
        this.preSelectedImage.endsWith("jpg") ||
        this.preSelectedImage.endsWith("jpeg") ||
        this.preSelectedImage.endsWith("jfif") ||
        this.preSelectedImage.endsWith("gif") ||
        this.preSelectedImage.endsWith("bmp") ||
        this.preSelectedImage.endsWith("webp")
      ) {
        this.image.type = "image_file";
        this.image.path = this.preSelectedImage;
      } else {
        this.image.type = "video_file";
        this.image.path = this.preSelectedImage;
      }
    } else {
      this.image.path = require("@/assets/media/images/upload_image.svg");
    }

    this.inputAccept = this.acceptVideo
      ? "video/* ,image/png, image/jpg, image/jpeg, image/jfif"
      : "image/png, image/jpg, image/jpeg, image/jfif";
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
  display: inline-block;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 5;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  transition: background 0.2s;
}

.remove-btn:hover {
  background: rgba(255, 0, 0, 0.8);
}
</style>
